export default "__VITE_ASSET__B9LhiXu7__"